import * as React from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Zoom from '@mui/material/Zoom';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { toast } from 'react-toastify';
import { httpGet, httpPost, httpPut, httpDelete } from '../../HttpRequestHandling/httpRequestHandler';
import { ClientUserRolesResources } from './ClientUserRolesResources';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { GridRowModes, useGridApiRef, GridActionsCellItem, } from '@mui/x-data-grid';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import CancelIcon from '@mui/icons-material/Close';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DoneIcon from '@mui/icons-material/Done';
import Box from '@mui/material/Box';
import { Check } from '@mui/icons-material';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import RemoveIcon from '@mui/icons-material/Remove';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddResources from '../Setup/AddResources';
import { ClientResourceLookup } from '../Lookups/ClientResourceLookup';
//import { POHeaderResourceClientLookup } from '../Lookups/POHeaderClientResourceLookup';


const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});
const updatedRowStore = {};
var currentEditRow = null;
export default function CLResourceMapping(props) {

	const companyCode = JSON.parse(localStorage.userInfo).companyCode;
	const apiGridRef = useGridApiRef();
	const [state, setState] = React.useState({
		data: [],
		companyCode: companyCode,
		userRolesList: [],
		mediaTypeList: [],
		openPasswordResetConfirmation: false,
		resetPasswordRowData: null,
		openDeleteConfirmation: false,
		bulkRouteToEmployee_clickHandler: false,
		openPOHeaderResourceClientDialog: false,
		deleteRowData: null,
		selectedRows: [],
		edit: null
	});
	const [openAddBoxDialog, setopenAddBoxDialog] = React.useState(false);
	const [openEmployeeRouteDialog, setopenEmployeeRouteDialog] = React.useState(false);
	const [openPOHeaderResourceClientDialog, setOpenPOHeaderResourceClientDialog] = React.useState(false);
	const [selectedTaxTypeCode, setSelectedTaxTypeCode] = React.useState(null);
	const [poheaderResource, setpoheaderResource] = React.useState(null);
	const [currentEditRowId, setCurrentEditRowId] = React.useState(null);
	const [pageSize, setPageSize] = React.useState(10);
	const [rowModesModel, setRowModesModel] = React.useState({});
	const [mediaType, setMediaType] = React.useState('');
	const [selectedMediaType, setSelectedMediaType] = React.useState('');
	const [checkboxStates, setCheckboxStates] = React.useState({});
	const [tooltipVisible, setTooltipVisible] = React.useState(false);
	const [tooltipContent, setTooltipContent] = React.useState("");
	const [clientcode, setClientcode] = React.useState('');
	const [clientname, setClientname] = React.useState('');
	const [globalUserRoles, setGlobalUserRoles] = React.useState([]);
	const [filteredData, setFilteredData] = React.useState([]);
	const [updatedRowStore, setUpdatedRowStore] = React.useState({});
	const [mediaTypeResources, setMediaTypeResources] = React.useState({});
	const [isSaveDisabled, setIsSaveDisabled] = React.useState(true);



	React.useEffect(() => {
		// Parse query parameters from URL
		const queryParams = new URLSearchParams(location.search);
		const code = queryParams.get('clientCode');
		const name = queryParams.get('clientName');

		if (code) setClientcode(code);
		if (name) setClientname(name);
	}, [location]);


	React.useEffect(() => {
		// First, fetch media types
		fetchMediaType()
			.then((mediaTypes) => {  // The data is already extracted in fetchMediaType
				const defaultMediaType = mediaTypes[0]?.mediaTypeId; // Set the first media type by default (if exists)

				setState((prev) => ({
					...prev,
					mediaTypeList: mediaTypes,  // Update the list of media types
					mediaType: defaultMediaType  // Set the default media type
				}));

				// Now fetch resources using the default media type and clientcode
				if (defaultMediaType && clientcode) {
					setSelectedMediaType(defaultMediaType);
					fetchResources(defaultMediaType, clientcode);  // Call fetchResources once mediaType is set
				}
			})
			.catch((error) => {
				toast.error('An error occurred while fetching media types');
				console.error('Error fetching media types!', error);
			});
	}, [clientcode, fetchMediaType]); // Make sure fetchMediaType is a dependency



	React.useEffect(() => {
		if (mediaType && clientcode) { // Ensure both values are set
			fetchResources(mediaType, clientcode); // Pass clientcode here
		}
	}, [mediaType, clientcode]); // Add mediaType and clientcode as dependencies

	React.useEffect(() => {
		fetchResources(mediaType).then((response) => {
			props.inProgress(true);

			httpGet("/api/positioncategory/")
				.then((response) => {
					/*	var userRolesList = response.data;*/

					const userRolesList = response.data.map((item) => ({
						userRoleId: item.positionCategoryCode,
						userRoleName: item.positionCategoryName
					}));

					props.inProgress(false);

					setState((prev) => ({ ...prev, userRolesList: userRolesList }));
				})
		}).catch((error) => {
			props.inProgress(false);

			toast.error('An error occurred while fetching the records');
			console.error('There was an error!', error);
		});
	}, [])


	//React.useEffect(() => {
	//	if (selectedMediaType) {
	//		const newFilteredData = state.data.filter(row => row.mediaType === selectedMediaType);
	//		setFilteredData(newFilteredData);
	//	} else {
	//		// If no media type is selected, you might want to reset the filtered data
	//		//setFilteredData(state.data);
	//		//const availableMediaTypes = new Set(state.data.map(row => row.mediaType));
	//		const availableMediaTypes = new Set(state.mediaTypeList.map(mediaType => selectedMediaType));
	//		const filteredDataBasedOnAvailableTypes = state.data.filter(row => availableMediaTypes.has(row.mediaType));
	//		setFilteredData(filteredDataBasedOnAvailableTypes);
	//	}
	//}, [selectedMediaType, state.data, state.mediaTypeList]);


	React.useEffect(() => {
		if (selectedMediaType) {
			// Check if the store has updated rows for the selected media type
			const updatedRows = updatedRowStore[selectedMediaType] || [];

			setIsSaveDisabled(updatedRows.length === 0);
			// Get unchanged rows from state.data that match the selected media type
			const unchangedRows = state.data.filter(row =>
				row.mediaType === selectedMediaType &&
				!updatedRows.some(updatedRow => updatedRow.resourceId === row.resourceId)
			);

			// Combine updated rows and unchanged rows
			const combinedRows = [...updatedRows, ...unchangedRows];

			// Map updated rows to ensure each has a unique ID
			const dataWithIds = combinedRows.map((row) => {
				const rolesFromGlobal = globalUserRoles[row.resourceId]?.[row.mediaType] || []; // Get roles from GlobalUserRoles for the resourceId
				return {
					...row,
					id: row.resourceId, // Ensure each row has a unique ID
					apadClientUserRolesResource: rolesFromGlobal.length > 0 ? rolesFromGlobal : row.apadClientUserRolesResource, // Override roles if available in GlobalUserRoles
				};
			});

			// Update the filtered data with the rows from the store
			setFilteredData(
				dataWithIds.length > 0
					? dataWithIds
					: state.data
						.filter(row => row.mediaType === selectedMediaType)
						.map((row) => {
							const rolesFromGlobal = globalUserRoles[row.resourceId]?.[row.mediaType] || []; // Check GlobalUserRoles for each resource
							return {
								...row,
								id: row.resourceId, // Ensure each row has a unique ID
								apadClientUserRolesResource: rolesFromGlobal.length > 0 ? rolesFromGlobal : row.apadClientUserRolesResource, // Override roles if found
							};
						})
			);
		} else {
			// Handle the case where no media type is selected
			const availableMediaTypes = new Set(state.mediaTypeList);

			const filteredDataBasedOnAvailableTypes = state.data
				.filter(row => availableMediaTypes.has(row.mediaType))
				.map((row) => {
					const rolesFromGlobal = globalUserRoles[row.resourceId]?.[row.mediaType] || []; // Check GlobalUserRoles for each resource
					return {
						...row,
						id: row.resourceId, // Ensure each row has a unique ID
						apadClientUserRolesResource: rolesFromGlobal.length > 0 ? rolesFromGlobal : row.apadClientUserRolesResource, // Override roles if found
					};
				});
			setFilteredData(filteredDataBasedOnAvailableTypes);
		}
	}, [selectedMediaType, state.data, state.mediaTypeList, updatedRowStore]);



	//React.useEffect(() => {
	//	if (selectedMediaType) {
	//		// Check if the store has updated rows for the selected media type
	//		if (updatedRowStore[selectedMediaType] && updatedRowStore[selectedMediaType].length > 0) {
	//			// Load rows from the store if there are updates
	//			setFilteredData(updatedRowStore[selectedMediaType]);
	//		} else {
	//			// If no updates in the store, filter rows from the original data
	//			const newFilteredData = state.data.filter(row => row.mediaType === selectedMediaType);
	//			setFilteredData(newFilteredData);
	//		}
	//	} else {
	//		// Handle the case where no media type is selected
	//		const availableMediaTypes = new Set(state.mediaTypeList.map(mediaType => selectedMediaType));
	//		const filteredDataBasedOnAvailableTypes = state.data.filter(row => availableMediaTypes.has(row.mediaType));
	//		setFilteredData(filteredDataBasedOnAvailableTypes);
	//	}
	//}, [selectedMediaType, state.data, state.mediaTypeList]);



	//const handleMediaTypeChange = (event) => {
	//	setSelectedMediaType(event.target.value); // Set the selected value
	//};
	const handleMediaTypeChange = (event) => {
		const selectedValue = event.target.value;
		setSelectedMediaType(selectedValue);
		//setMediaType(selectedValue); // Set media type and trigger resource fetching

		//if (selectedValue && clientcode) {
		//	fetchResources(selectedValue, clientcode);
		//}
	};

	const handleResourcesSelected = (selectedResources) => {

		// Create a unique set of selected resource IDs to avoid duplicates
		const selectedResourceIds = new Set(selectedResources.map(row => row.resourceId));

		// Update the grid data by merging selected resources with existing filtered data
		const updatedData = [...filteredData];

		// Remove duplicates based on resourceId
		const uniqueData = updatedData.filter(
			(resource, index, self) =>
				index === self.findIndex((r) => r.resourceId === resource.resourceId)
		);

		const dataWithIds = uniqueData.map((resource) => ({
			...resource,
			id: resource.resourceId, // Use resourceId as the unique id
		}));

		// Update the grid data
		setFilteredData(dataWithIds);

		setUpdatedRowStore((prevStore) => {
			// Create a new copy of the previous store
			const newStore = { ...prevStore };

			// Initialize the mediaType if it doesn't exist
			if (!newStore[selectedMediaType]) {
				newStore[selectedMediaType] = [];
			}

			// Filter out any existing entries for selected resources
			newStore[selectedMediaType] = newStore[selectedMediaType].filter(row => !selectedResourceIds.has(row.resourceId));

			// Push the new selected resources to the store
			newStore[selectedMediaType].push(...filteredData, ...selectedResources);

			// Ensure unique records based on resourceId
			newStore[selectedMediaType] = newStore[selectedMediaType].filter(
				(resource, index, self) =>
					index === self.findIndex((r) => r.resourceId === resource.resourceId)
			);

			newStore[selectedMediaType].sort((a, b) => a.id.localeCompare(b.id));

			return newStore; // Return the updated store
		});

		setIsSaveDisabled(selectedResources.length === 0);
	};



	const getRefreshButton = React.useCallback((event) => {
		return <IconButton
			variant="contained"
			onClick={refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10, display: 'none' }}>
			<RefreshIcon />
		</IconButton>;
	}, [state.data, currentEditRowId])



	const refresh_clickHandler = React.useCallback((event) => {
		setUpdatedRowStore([]);
		fetchResources(mediaType, clientcode);
		//props.inProgress(true);
		//let functionName = "getresources";
		//let messageName = "Resources";
		//httpGet("/api/Adapter/getSyncData/" + functionName)
		//	.then(response => {
		//		var data = response.data;
		//		props.inProgress(false);
		//		if (data)
		//			toast.success(messageName + ' Fetched Successfully');
		//		else
		//			toast.error('Error fetching ' + messageName);

		//	}).catch((error) => {
		//		props.inProgress(false);
		//		toast.error('Error fetching ' + messageName);
		//	});
	}, [mediaType, clientcode])



	const fetchResources = React.useCallback((mediatype, clientcode) => {
		props.inProgress(true);
		var promise = httpGet("/api/resources/clientmediatype?mediatypeid=" + mediatype + "&clientcode=" + clientcode + "")
			.then((response) => {

				var data = response.data?.resources || [];
				var rowId = 1;

				data.map(row => row.rowId = rowId++);

				props.inProgress(false);

				setState((prev) => ({ ...prev, data: data }));
			}).catch((error) => {
				props.inProgress(false);

				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});

		return promise;
	}, [])

	const fetchMediaType = React.useCallback(() => {
		props.inProgress(true);

		// Return the promise, ensuring that the data is returned properly
		return httpGet("/api/userroles/mediatypelist")
			.then((response) => {
				props.inProgress(false);
				return response.data;  // Return the actual data
			})
			.catch((error) => {
				props.inProgress(false);
				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
				throw error;  // Re-throw the error to handle it in useEffect
			});
	}, [props]);

	const rolesMapping = React.useMemo(() => {
		const mapping = {};
		globalUserRoles.forEach(role => {
			const key = `${role.resourceId}-${role.mediaTypeId}`; // Create a unique key with resourceId and mediaTypeId
			if (!mapping[key]) {
				mapping[key] = [];
			}
			mapping[key].push(role);
		});
		return mapping;
	}, [globalUserRoles]);

	const saveAllResources = React.useCallback((updatedRows) => {
		const rowData = structuredClone(updatedRows);

		rowData.forEach(row => {
			row.companyCode = parseInt(state.companyCode);
			row.rowId = row.rowId || 0; // Default to 0 for new records
		});

		const httpMethod = rowData.length > 0 && rowData[0].rowId === 0 ? httpPost : httpPut;

		props.inProgress(true);

		httpMethod("/api/resources/clientresources", rowData)
			.then((response) => {
				toast.success('All records saved successfully!');
				fetchResources(mediaType, clientcode); // Refresh the resources after saving
				setIsSaveDisabled(true);
			})
			.catch((error) => {
				const errorMessage = error.response?.data
					? `Error: ${error.response.data.title || 'Unknown Error'}`
					: 'An unknown error occurred.';
				toast.error(<div>{errorMessage}</div>);
			})
			.finally(() => {
				props.inProgress(false);
			});
	}, [state.companyCode, props]);



	const handleSaveAll = async () => {
		try {
			// Get the current data from the grid

			const updatedRows = Object.values(updatedRowStore).flatMap((rows) =>
				rows.map(row => {
					return {
						resourceId: row.resourceId,
						resourceName: row.resourceName,
						isActive: row.isActive,
						clientCode: row.clientCode,
						mediaType: row.mediaType,
						// Fetch the roles from globalUserRoles for the current row, or retain existing roles
						//apadClientUserRolesResource: globalUserRoles.filter(role => role.resourceId === row.resourceId && role.mediaTypeId === row.mediaType) || row.apadClientUserRolesResource
						apadClientUserRolesResource:
							globalUserRoles.filter(role => role.resourceId === row.resourceId && role.mediaTypeId === row.mediaType).length > 0
								? globalUserRoles.filter(role => role.resourceId === row.resourceId && role.mediaTypeId === row.mediaType)
								: row.apadClientUserRolesResource || []
					};
				})
			);

			const hasInvalidRoles = updatedRows.some(row => {
				const roles = row.apadClientUserRolesResource || [];
				const hasNoRoles = roles.length === 0;
				const hasInvalidUserRoleId = roles.some(role => role.userRoleId <= 0);
				return hasNoRoles || hasInvalidUserRoleId;
			});

			if (hasInvalidRoles) {
				alert('Error: All resources must have selected roles.');
				return;
			}

			if (updatedRows.length === 0) {
				alert('No updated rows to save.');
				return;
			}
			props.inProgress(true);
			await saveAllResources(updatedRows);
			//const response = await axios.post('/api/resources/clientresources', updatedRows);

			// Check for success
			if (response.status === 200) {
				alert('All records saved successfully!');
				// Optionally refresh data or perform further actions
				fetchResources(mediaType, clientcode); // Refresh the resource data if needed
				props.inProgress(false);
			} else {
				alert('Failed to save records. Please try again.');
			}
		} catch (error) {
			// Handle any errors that occurred during the API call
			console.error('Error saving records:', error);
			props.inProgress(false);
			//alert('An error occurred while saving records. Please check the console for more details.');
		}
	};

	const handlerefresh = async () => {
		setUpdatedRowStore([]);
		fetchResources(mediaType, clientcode);
	};

	const handleBack_clickHandler = (event) => {
		event.preventDefault(); // Prevent default behavior
		window.history.back(); // Navigate to the previous page
	};

	const saveResources = React.useCallback((newdata, oldData) => {
		let rowdata = structuredClone(newdata);
		if (newdata.isNew) {
			rowdata.rowId = 0;
		}
		rowdata.companyCode = parseInt(state.companyCode);
		var httpMethod = rowdata.rowId === 0 ? httpPost : httpPut;

		props.inProgress(true);

		httpMethod("/api/resources/", rowdata)
			.then((response) => {
				props.inProgress(false);
				toast.success('Updated Successfully');
				//resolve();
				currentEditRow = null;
				fetchResources();
			}).catch((error) => {
				//reject();
				if (newdata?.isNew) {
					setState((prev) => ({ ...prev, data: state.data.filter(e => e.rowId !== newdata.rowId) }))
				} else {
					apiGridRef.current.updateRows([{ id: newdata.rowId, ...oldData }])
				}
				props.inProgress(false);
				toast.error(<div>Resources Update Failed<br />{error.response.data}</div>);
			});
	}, [state.companyCode, state.data])

	//const saveResourcesclientside = React.useCallback((newdata, oldData) => {
	//	let rowdata = structuredClone(newdata);
	//	if (newdata.isNew) {
	//		rowdata.rowId = 0;
	//	}
	//	rowdata.companyCode = parseInt(state.companyCode);
	//	var httpMethod = rowdata.rowId === 0 ? httpPost : httpPut;
	//	if (newdata?.isNew) {
	//		setState((prev) => ({ ...prev, data: state.data.filter(e => e.rowId !== newdata.rowId) }))
	//	} else {
	//		apiGridRef.current.updateRows([{ id: newdata.rowId, ...oldData }])
	//	}
	//	props.inProgress(false);

	//}, [state.companyCode, state.data])

	const saveResourcesclientside = React.useCallback((newdata, oldData) => {
		let rowdata = structuredClone(newdata);

		if (newdata.isNew) {
			rowdata.rowId = 0; // If the row is new, set rowId to 0
		}

		rowdata.companyCode = parseInt(state.companyCode); // Add company code to the row data

		const globalRoles = globalUserRoles[rowdata.resourceId]?.[rowdata.mediaType] || [];

		// Update apadClientUserRolesResource if roles from global exist
		rowdata.apadClientUserRolesResource = globalRoles.length > 0
			? globalRoles
			: rowdata.apadClientUserRolesResource; // Fallback to existing roles if no update

		const mediaType = rowdata.mediaType;

		// Clone the store to ensure immutability
		const updatedStore = { ...updatedRowStore };

		// Store the updated row in the store against the media type
		if (!updatedStore[mediaType]) {
			updatedStore[mediaType] = [];
		}

		updatedStore[mediaType] = updatedStore[mediaType].filter(row => row.rowId !== rowdata.rowId);

		// Add the updated row to the store with updated roles
		updatedStore[mediaType].push(rowdata);

		// Assign back to the original store
		Object.assign(updatedRowStore, updatedStore);
		if (newdata?.isNew) {
			setState((prev) => ({
				...prev,
				data: state.data.filter(e => e.rowId !== newdata.rowId)
			}));
		} else {
			apiGridRef.current.updateRows([{ id: newdata.rowId, ...oldData }]);
		}

		props.inProgress(false); // End the progress indicator
	}, [state.companyCode, state.data, globalUserRoles]);

	const deleteResources = React.useCallback(() => {
		props.inProgress(true);
		let data = state.deleteRowData;
		setState((prev) => ({ ...prev, openDeleteConfirmation: false, deleteRowData: null }));
		// Check if the resourceId is available in state.data
		const resourceExists = state.data.some(row =>
			row.resourceId === data.resourceId && row.mediaType === selectedMediaType
		);
		if (resourceExists) {
			httpDelete("/api/resources/client?resourceId=" + encodeURIComponent(data.resourceId) + "&mediatype=" + selectedMediaType + "&clientcode=" + clientcode)
				.then((response) => {
					props.inProgress(false);
					toast.success('Deleted Successfully');

					setUpdatedRowStore((prevStore) => {
						let updatedStore = { ...prevStore };
						if (updatedStore[selectedMediaType]) {
							updatedStore[selectedMediaType] = updatedStore[selectedMediaType].filter(row => row.resourceId !== data.resourceId);
						}
						return updatedStore;
					});

					fetchResources(mediaType, clientcode);

					setState((prev) => ({
						...prev,
						data: prev.data.filter(row => row.resourceId !== data.resourceId || row.mediaType !== selectedMediaType)
					}));

					// Update the grid's filtered data to reflect the removal
					setFilteredData((prevFiltered) =>
						prevFiltered.filter(row => row.resourceId !== data.resourceId || row.mediaType !== selectedMediaType)
					);
				}).catch((error) => {
					props.inProgress(false);

					if (error.response.data.includes("Cannot delete, record being referenced by other entities.")) {
						toast.error("Cannot delete, record being referenced by other entities.");
					}
					else {
						toast.error(<div>Delete Failed<br />{error.response.data}</div>);
					}
				});
		} else {
			// Resource is not in state.data, so only remove it from the grid and store
			setUpdatedRowStore((prevStore) => {
				let updatedStore = { ...prevStore };
				if (updatedStore[selectedMediaType]) {
					updatedStore[selectedMediaType] = updatedStore[selectedMediaType].filter(row => row.resourceId !== data.resourceId);
				}
				return updatedStore;
			});

			// Update the grid by removing the row from the state data
			setState((prev) => ({
				...prev,
				data: prev.data.filter(row => row.resourceId !== data.resourceId || row.mediaType !== selectedMediaType)
			}));

			// Update the grid's filtered data
			setFilteredData((prevFiltered) =>
				prevFiltered.filter(row => row.resourceId !== data.resourceId || row.mediaType !== selectedMediaType)
			);

			props.inProgress(false); // End the progress indicator
			toast.success('Deleted Successfully');
		}
	}, [state.deleteRowData, state.data, mediaType])

	const isRecordValid = React.useCallback((data) => {
		var returnValue = true;
		return returnValue;
		var message = "";

		const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (data.resourceId === null || data.resourceId === undefined || data.resourceId.trim().length === 0) {
			message += "Resource Id, ";
		}
		if (data.nameFirst === null || data.nameFirst === undefined || data.nameFirst.trim().length === 0) {
			message += "First Name, ";
		}
		if (data.nameLast === null || data.nameLast === undefined || data.nameLast.trim().length === 0) {
			message += "Last Name, ";
		}
		if (data.email && data.email.trim().length > 0 && !regex.test(data.email.toLowerCase())) {
			message += "valid Email, ";
		}
		if (data.loginId === null || data.loginId === undefined || data.loginId.trim().length === 0) {
			message += "Login Id, ";
		}

		if (message.length > 0) {
			message = message.substr(0, message.length - 2);

			if (message.indexOf(", ") !== -1) {
				var index = message.lastIndexOf(",");
				message = message.substring(0, index) + " and" + message.substring(index + 1);
			}

			toast.error("Please Provide " + message);

			returnValue = false;
		}

		return returnValue;
	}, [])

	//const getUserRoleName = React.useCallback((apadClientUserRolesResource) => {
	//	var assignedUserRolesResources = "";

	//	if (state.userRolesList.length > 0 && apadClientUserRolesResource && apadClientUserRolesResource.length > 0) {
	//		assignedUserRolesResources = state.userRolesList.find(ur => ur.userRoleId === apadClientUserRolesResource[0].userRoleId).userRoleName + (apadClientUserRolesResource.length > 1 ? "..." : "");
	//	}

	//	return assignedUserRolesResources;
	//}, [state, state.edit])

	const getUserRoleName = React.useCallback((apadClientUserRolesResource) => {
		let assignedUserRolesResources = [];

		// Check if there are user roles available
		if (state.userRolesList.length > 0 && apadClientUserRolesResource && apadClientUserRolesResource.length > 0) {
			// Get the user role names for the provided user role IDs
			assignedUserRolesResources = apadClientUserRolesResource.map(role => {
				const userRole = state.userRolesList.find(ur => ur.userRoleId === role.userRoleId);
				return userRole ? userRole.userRoleName : '';
			}).filter(name => name); // Filter out any undefined or empty names

			// Join the names with a comma
			const joinedNames = assignedUserRolesResources.join(', ');

			// Check if the joined names exceed 100 characters
			if (joinedNames.length > 100) {
				// Trim to 100 characters and append "..."
				return `${joinedNames.substring(0, 100)}...`;
			}

			return joinedNames; // Return the joined names if under 100 characters
		}

		return ""; // Return an empty string if no roles are found
	}, [state, state.edit]);

	const getUserRoleNameCSV = React.useCallback((apadUserRolesResource) => {
		var assignedUserRolesResources = [];
		if (state.userRolesList.length > 0 && apadUserRolesResource && apadUserRolesResource.length > 0) {
			apadUserRolesResource.map((userRolesResource, index) => (
				assignedUserRolesResources.push(state.userRolesList.find(ur => ur.userRoleId === userRolesResource.userRoleId).userRoleName)
			))
		}

		return assignedUserRolesResources.join(", ");
	}, [state, state.edit])

	const getUserRoleNameList = React.useCallback((apadClientUserRolesResource) => {
		return (<ul key={2} style={{ margin: 0, pading: 0, listStyle: 'none' }}> {(apadClientUserRolesResource)
			.map((e, ei) => {
				let rolename = state.userRolesList.find(ur => ur.userRoleId === e.userRoleId)?.userRoleName;
				return (rolename && <li key={ei}>{rolename}</li>) || <></>
			})}</ul>)
	}, [state, state.edit])

	const selectedUserRoles_onClose = React.useCallback((selectedUserRoles) => {
		if (selectedUserRoles) {
			const apadClientUserRolesResource = selectedUserRoles.map(userRolesResource => ({
				companyCode: userRolesResource.companyCode,
				resourceId: currentEditRow.resourceId,
				userRoleId: parseInt(userRolesResource.userRoleId, 10),
				mediaTypeId: currentEditRow.mediaType
			}));

			currentEditRow.apadClientUserRolesResource = apadClientUserRolesResource;

			setGlobalUserRoles(prevRoles => {
				// Filter out roles for the current edit row (remove old ones)
				const updatedRoles = prevRoles.filter(
					role => !(role.resourceId === currentEditRow.resourceId && role.mediaTypeId === currentEditRow.mediaType)
				);

				// Merge the updated roles for the current edit row
				return [
					...updatedRoles, // Keep other rows' roles
					...apadClientUserRolesResource // Add new roles for the current row
				];
			});

			setUpdatedRowStore(prevStore => {
				const newStore = { ...prevStore };
				const mediaType = currentEditRow.mediaType;

				if (!newStore[mediaType]) {
					newStore[mediaType] = [];
				}

				newStore[mediaType] = newStore[mediaType].filter(row => row.resourceId !== currentEditRow.resourceId);

				newStore[mediaType].push({ ...currentEditRow });

				// Sort the rows by id or any other criteria
				newStore[mediaType].sort((a, b) => a.id.localeCompare(b.id));

				return newStore;
			});

			setState((prev) => ({ ...prev, dummy: null, edit: { ...prev.edit, apadClientUserRolesResource: apadClientUserRolesResource } }));

			setIsSaveDisabled(apadClientUserRolesResource.length === 0);
		}
	}, [state]);


	//const selectedUserRoles_onClose = React.useCallback((selectedUserRoles) => {
	//	if (selectedUserRoles) {
	//		// Create an array to hold the selected roles
	//		const apadClientUserRolesResource = selectedUserRoles.map(userRolesResource => ({
	//			companyCode: userRolesResource.companyCode,
	//			resourceId: currentEditRow.resourceId, // Ensure this is correct for the current resource
	//			userRoleId: parseInt(userRolesResource.userRoleId, 10)
	//		}));

	//		// Update the specific row in the state data instead of using currentEditRow directly
	//		setState(prev => ({
	//			...prev,
	//			dummy: null,
	//			data: prev.data.map(row => {
	//				if (row.resourceId === currentEditRow.resourceId) {
	//					// Update the specific row's roles
	//					return { ...row, apadClientUserRolesResource };
	//				}
	//				return row; // Return the row unchanged if it doesn't match
	//			}),
	//		}));
	//	}
	//}, [state]);

	const resources_resetPasswordClickHandler = React.useCallback((rowData) => {
		setState((prev) => ({ ...prev, openPasswordResetConfirmation: true, resetPasswordRowData: rowData }));
	}, [])


	const resources_DeleteClickHandler = React.useCallback((rowData) => {
		setState((prev) => ({ ...prev, openDeleteConfirmation: true, deleteRowData: rowData }));
	}, [])

	const closeDialog = React.useCallback((event) => {
		setState((prev) => ({ ...prev, openPasswordResetConfirmation: false, resetPasswordRowData: null }));
	}, [])


	const closeDeleteDialog = React.useCallback((event) => {
		setState((prev) => ({ ...prev, openDeleteConfirmation: false, deleteRowData: null }));
	}, [])

	const taxMapsDialog_closeHandler = () => {
		setopenAddBoxDialog(false);
	};

	const employeeRoute_closeHandler = () => {
		setopenEmployeeRouteDialog(false);
	};

	const resetPasswordYes_clickHandler = React.useCallback((event) => {
		var url = "/api/resources/resetpassword/";
		var rowData = state.resetPasswordRowData;

		setState((prev) => ({ ...prev, openPasswordResetConfirmation: false, resetPasswordRowData: null }));

		props.inProgress(true);

		httpPost(url, rowData)
			.then((response) => {
				props.inProgress(false);

				toast.success('Password reset Successfully');
			}).catch((error) => {
				props.inProgress(false);

				toast.error('Password reset Failed');
			});
	}, [state])

	const bulkRouteToEmployee_clickHandler = (event) => {
		event.preventDefault();
		setopenEmployeeRouteDialog(true);
		setOpenPOHeaderResourceClientDialog(false);
		setClientcode(clientcode);
		setMediaType(mediaType);
	};

	const openExistingPopup = () => {
		setPopupOpen(true); // Assuming you have state to control the popup visibility
	};

	//const handleMediaTypeChange = (event) => {
	//	const selectedValue = event.target.value;
	//	setMediaType(selectedValue); // Update state with the selected media type
	//	fetchResources();
	//	console.log("Selected Media Type:", selectedValue);
	//	// You can also trigger additional logic based on selected media type here
	//};
	/////////////////////////////////////////////////////////

	const getAddButton = React.useCallback(() => {
		return <IconButton
			key={1}
			disabled={!!currentEditRowId}
			variant="contained"
			onClick={bulkRouteToEmployee_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10 }}
		>
			<Tooltip key={1} title={'add'}><AddBoxIcon key={2} /></Tooltip>
		</IconButton>;
	}, [state.data, currentEditRowId])


	const handleAddClick = React.useCallback(() => {
		const id = ([...state.data]?.sort((a, b) => b.rowId - a.rowId)[0]?.rowId + 1) || 1;
		//apiGridRef.current.setPage(Math.ceil((state.data.length+1) / pageSize));
		let model = {};
		model.rowId = id;
		model.isNew = true;
		let field = 'resourceId';
		setCurrentEditRowId(id);
		setState((prev) => ({
			...prev, isDirty: true, data: [model, ...prev.data]
		}));
		setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit, fieldToFocus: field } })
		//apiGridRef.current.startRowEditMode({ id: id, fieldToFocus: field });

	}, [state.data]);

	const processRowUpdate = React.useCallback((newrow, oldrow) => {
		let _newrow = structuredClone(newrow);
		if (!isRecordValid(_newrow)) {
			throw new Error('')
			setRowModesModel({ ...rowModesModel, [_newrow.rowId]: { mode: GridRowModes.Edit } })
		}

		setCurrentEditRowId(null);
		//if (_newrow?.isNew) apiGridRef.current.setPage(0);
		_newrow.apadClientUserRolesResource = state.edit?.apadClientUserRolesResource
			|| currentEditRow.apadClientUserRolesResource;
		setState((prev) => ({ ...prev, edit: null }))
		saveResourcesclientside(_newrow, oldrow);
		return _newrow;
	}, [state, state.edit]);

	const handleRowClick = React.useCallback((params, event) => {
		if (!params.isEditable) {
			return;
		}
		if (!event.currentTarget.contains(event.target)) {
			return;
		}
		if (params.cellMode == GridRowModes.View) {
			apiGridRef.current.startRowEditMode({ id: params.id });
		}
	}, [state])

	const AddButtonClick = (event) => {
		event.preventDefault();
		setopenAddBoxDialog(true);
		setSelectedTaxTypeCode(event.target.dataset.taxCode);

		//this.setState({ openLevel3Dialog: true, selectedLevel2Key: event.target.dataset.level2key });

	};

	const handlePageSizeChange = React.useCallback((newpagesize) => {
		setPageSize((prev) => (newpagesize));
	}, [state])




	const handleEditClick = (id) => {
		setCurrentEditRowId(id);
		setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
	};

	const handleSaveClick = (newData) => {
		setRowModesModel({ ...rowModesModel, [newData.rowId]: { mode: GridRowModes.View } });
	};

	const handleCancelClick = (id) => {
		setCurrentEditRowId(null);
		setRowModesModel({
			...rowModesModel,
			[id]: { mode: GridRowModes.View, ignoreModifications: true },
		});
		const editedRow = state.data.find((row) => row.rowId === id);
		//if (editedRow?.isNew) {
		//	apiGridRef.current.setPage(0);

		//}
		setState((prev) => {
			return (editedRow?.isNew) ? { ...prev, edit: null, data: state.data.filter((row) => row.rowId !== id) }
				: { ...prev, edit: null }
		});
	};

	const allResourceIds = new Set();

	state.data
		.filter(row => row.mediaType === selectedMediaType) // Filter by selected media type
		.forEach(row => {
			allResourceIds.add(row.resourceId);
		});

	const updatedResourceRows = updatedRowStore[selectedMediaType] || [];
	updatedResourceRows.forEach(row => {
		allResourceIds.add(row.resourceId);
	});
	const uniqueResourceIds = Array.from(allResourceIds);
	const info = {
		taxTypeCode: selectedTaxTypeCode,
		inProgress: props.inProgress
	};
	const rowCount = filteredData.length;
	const greatestRowId = filteredData.length > 0
		? Math.max(...filteredData.map(row => row.rowId)) // Map the rowId and find the maximum
		: 0;
	const poHeaderResourceInfo = {
		inProgress: props.inProgress,
		openDialog: true,
		vendorCode: null,
		siteId: null,
		invoiceDocumentId: false,
		clientCode: clientcode,
		mediaType: selectedMediaType,
		companyCode: companyCode,
		rCount: greatestRowId,
		resourceIds: uniqueResourceIds

	};
	//////////////////////////////////////////////////////////
	const displaySave = (state.readOnly) ? "none" : "";
	return (
		<div>
			<h1>Customer Resource Mapping</h1>
			<div className="form-group">
				<h6 style={{ margin: 0, fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', fontWeight: 500, fontSize: '1.25rem', lineHeight: 1.6, letterSpacing: '0.0075em' }}>Customer : {clientcode} - {clientname} </h6>
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '30px 0px 30px 10px' }}>
					<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<h5 style={{ margin: 0 }}>Media Type :</h5>
						<select
							style={{
								width: '200px',
								borderRadius: '11px',
								backgroundColor: '#FFFFFF',
								border: "1px solid #E3E3E3",
								height: "35px",
								boxShadow: "none",
								fontFamily: "system-ui",
								padding: "0px 0px 2px 2px",
								fontSize: '14px'
							}}
							value={selectedMediaType}
							onChange={handleMediaTypeChange}
						>
							{state.mediaTypeList.map((mediaTypeItem) => (
								<option key={mediaTypeItem.mediaTypeId} value={mediaTypeItem.mediaTypeId}>
									{mediaTypeItem.mediaTypeName}
								</option>
							))}
						</select>
					</div>

					<div style={{
						backgroundColor: '#F0F8FF',
						border: '1px solid #B0C4DE',
						borderRadius: '8px',
						padding: '8px 12px',
						marginRight: '10px',
						fontFamily: 'system-ui',
						fontSize: '14px',
						color: '#333333'
					}}>
						<Typography variant="body2" align="right" style={{ margin: 0 }}>
							Note: Media Type/Resource(s) changes will take effect on the next data sync.
						</Typography>
					</div>
				</div>
				<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
					<EnhancedDataGrid rows={filteredData}
						disableColumnMenu
						pagination
						pageSize={10}
						title={"Customer Resources"}
						editMode="row"
						onCellClick={handleRowClick}
						processRowUpdate={processRowUpdate}
						onProcessRowUpdateError={(err) => { }}
						disableSelectionOnClick
						apiRef={apiGridRef}
						customcomponent={
							(<>
								{getRefreshButton()}
								{getAddButton()}
							</>)
						}
						rowModesModel={rowModesModel}
						onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
						columns={[

							{
								headerName: 'Resource Code',
								field: 'resourceId',
								cellClassName: "MuiInputBase-input MuiInput-input",
								renderCell: (props) => {
									return <span>{props.row.resourceId}</span>
								},
								renderEditCell: (props) => {
									let row = props.row;
									if (!row.isNew) {
										return <span>{row.resourceId}</span>
									} else {
										return <input
											type="text"
											aria-invalid="false"
											placeholder=""
											value={row.resourceId || ''}
											className="MuiInputBase-input MuiInput-input"
											style={{ width: '100%' }}
											onChange={(event) => {
												const newValue = event.target.value;
												const { id, api, field, value } = props;// The new value entered by the user
												api.setEditCellValue({ id, field, value: newValue })
											}
											}
										/>
									}
								},
								width: 200,
								editable: true,
							},
							{
								headerName: 'Resource Name',
								field: 'resourceName',
								width: 300
							},

							{
								headerName: 'Active',
								field: 'isActive',
								type: 'boolean',
								width: 200,
								headerAlign: 'center',
								align: 'center',
								editable: true,
								renderCell: (props) => (
									<Checkbox
										key={props.id}  // Unique key for the row
										color="default"
										checked={props.value}  // Current state of the checkbox
										onChange={(e) => {
											const newValue = e.target.checked;  // The new value when the checkbox is toggled
											const updatedRow = { ...props.row, activeFlag: newValue };  // Clone the row and update the 'activeFlag'
											setIsSaveDisabled(false);
											// Directly update the row in the grid
											props.api.updateRows([updatedRow]);

										}}
									/>
								),

							},
							{
								headerName: 'Role(s)',
								field: 'apadClientUserRolesResource',
								width: 600,
								headerAlign: 'center',
								align: 'center',
								editable: true,
								renderCell: rowData => {
									return (<div key={1}>
										<Tooltip key={2} title={getUserRoleNameList(rowData?.row?.apadClientUserRolesResource || [])}>
											<Typography variant="inherit">{getUserRoleName(rowData.row.apadClientUserRolesResource)}</Typography>
										</Tooltip>
									</div>)
								},
								renderEditCell: props => {
									currentEditRow = props.row;

									const info = {
										userRolesList: state.userRolesList,
										apadClientUserRolesResource: props.row.apadClientUserRolesResource ? props.row.apadClientUserRolesResource : []
									};

									return <Box
										key={1}
										sx={{
											display: 'flex',
											flexDirection: 'row'
										}}>
										<Tooltip key={2} title={getUserRoleNameList((state.edit?.apadClientUserRolesResource || currentEditRow.apadClientUserRolesResource) || [])}>
											<Typography key={3} sx={{
												pt: '10px'
											}}
												variant="inherit">{getUserRoleName(state.edit?.apadClientUserRolesResource || currentEditRow.apadClientUserRolesResource)}</Typography>
										</Tooltip>
										<ClientUserRolesResources info={info} onClose={selectedUserRoles_onClose} />
									</Box>
								},

							},


							{
								field: 'actions',
								type: 'actions',
								headerName: 'Actions',
								width: 100,
								headerAlign: 'right',
								align: 'right',
								cellClassName: 'actions',
								getActions: (rowData) => {
									const isInEditMode = rowModesModel[rowData.id]?.mode === GridRowModes.Edit;

									//if (isInEditMode) {
									//	return [
									//		<GridActionsCellItem
									//			key={rowData.id + 1}
									//			icon={<Tooltip key={rowData.id + 2} title={'Save'}>
									//				<DoneIcon key={rowData.id + 1} />
									//			</Tooltip>}
									//			label="Save"
									//			color="inherit"
									//			onClick={() => { handleSaveClick(rowData.row) }}

									//		/>,
									//		<GridActionsCellItem
									//			key={rowData.id + 2}
									//			icon={<Tooltip key={rowData.id + 2} title={'Cancel'}>
									//				<CancelIcon key={rowData.id + 1} />
									//			</Tooltip>}
									//			label="Cancel"
									//			className="textPrimary"
									//			onClick={() => { handleCancelClick(rowData.id) }}
									//			color="inherit"
									//		/>,
									//	];
									//}

									return [
										//<GridActionsCellItem
										//	key={rowData.id + 2}
										//	icon={<Tooltip key={rowData.id + 2} title={'Edit'}>
										//		<EditIcon key={rowData.id + 1} />
										//			</Tooltip>}
										//	label="Edit"
										//	className="textPrimary"
										//	onClick={() => { handleEditClick(rowData.id) }}
										//	color="inherit"
										//	disabled={currentEditRowId && currentEditRowId !== rowData.id}
										///>,
										<GridActionsCellItem
											key={rowData.id + 3}
											icon={<Tooltip key={rowData.id + 2} title={'Delete'}>
												<DeleteIcon key={rowData.id + 1} />
											</Tooltip>}
											label="Delete"
											onClick={() => { resources_DeleteClickHandler(rowData.row) }}
											color="inherit"
											disabled={currentEditRowId && currentEditRowId !== rowData.id}
										/>,
									];
								},
							},

						]}
						onPageSizeChange={handlePageSizeChange}
						getRowId={(row) => row.rowId}
						editable={
							{
								onRowAdd: newData =>
									new Promise((resolve, reject) => {
										newData.rowId = 0;
										newData.companyCode = parseInt(state.companyCode);

										if (isRecordValid(newData)) {
											newData.apadUserRolesResource = that.currentEditRow.apadUserRolesResource;

											saveResources(newData, resolve, reject);
										}
										else {
											reject();
										}
									}),
								onRowUpdate: (newData, oldData) =>
									new Promise((resolve, reject) => {

										if (isRecordValid(newData)) {
											newData.apadClientUserRolesResource = that.currentEditRow.apadClientUserRolesResource;

											saveResources(newData, resolve, reject);
										}
										else {
											reject();
										}
									}),
								onRowDelete: oldData =>
									new Promise((resolve, reject) => {
										deleteResources(oldData, resolve, reject);
									}),
								onRowAddCancelled: rowData =>
									new Promise((resolve, reject) => {
										setState({ selectedUserRoleIds: [], initializeSelectedUserRoleIds: true });
									}),
								onRowUpdateCancelled: rowData =>
									new Promise((resolve, reject) => {
										setState({ selectedUserRoleIds: [], initializeSelectedUserRoleIds: true });
									})
							}
						}
					/>
				</div>

			</div>
			{/*<div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>*/}
			{/*<Button variant="contained" color="primary" onClick={handleSaveAll}>*/}
			{/*	Save All*/}
			{/*</Button>*/}
			<div className="floatingButtons" style={{ width: "60%" }}>
				<div className="row-form row-btn" style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
					<button className="btn-blue" style={{ display: displaySave, marginRight: '5px' }} disabled={isSaveDisabled} onClick={handleSaveAll}>Save</button>
					<button className="btn-blue" style={{ display: displaySave, backgroundColor: 'rgb(159, 155, 155)', border: '1px solid rgb(159, 155, 155)' }} onClick={handlerefresh}>Reset</button>
					<button className="btn-grey" style={{ marginLeft: '-5px' }} onClick={handleBack_clickHandler}>Back</button>
				</div>
			</div>
			{/*</div>*/}
			<Dialog open={openAddBoxDialog} TransitionComponent={Transition} fullWidth maxWidth="lg">
				<DialogContent>
					<AddResources info={info} onClose={taxMapsDialog_closeHandler} />
				</DialogContent>
			</Dialog>
			<Dialog open={openEmployeeRouteDialog}>
				<DialogContent>
					<ClientResourceLookup info={poHeaderResourceInfo} onClose={employeeRoute_closeHandler} onResourcesSelected={handleResourcesSelected} />
				</DialogContent>
			</Dialog>

			<Dialog
				open={state.openPasswordResetConfirmation}
				aria-labelledby="draggable-dialog-title"
			>
				<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
					Reset Password
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Are you sure you want to reset password for login id "{state.resetPasswordRowData ? state.resetPasswordRowData.loginId : ""}" ?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={resetPasswordYes_clickHandler} color="primary">
						Yes
					</Button>
					<Button autoFocus onClick={closeDialog} color="primary">
						No
					</Button>
				</DialogActions>
			</Dialog>


			<Dialog
				open={state.openDeleteConfirmation}
				aria-labelledby="draggable-dialog-title"
			>
				<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
					Delete Record
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Are you sure you want to delete the Resource "{state.deleteRowData ? state.deleteRowData.resourceName : ""}" ?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={deleteResources} color="primary">
						Yes
					</Button>
					<Button autoFocus onClick={closeDeleteDialog} color="primary">
						No
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);

} 